import styled from 'styled-components';

export const EventContent = styled.div`
    padding: 1rem 1.25rem 0.5rem 1.25rem;

    /* Il primo blocco si appoggia al riepilogo: niente riga in mezzo */
    &:first-child .event-summary {
        border-top: none;
    }

    .event-summary {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 1rem;
        border-bottom: ${(props) => props.theme.DefaultBorder};
        border-top: ${(props) => props.theme.DefaultBorder};
        padding: 0.75rem 0;

        .event-item-title {
            font-weight: bold;
            text-transform: uppercase;
        }

        /* Il tag va centrato sulla riga del titolo, non sul bordo alto del blocco */
        .event-item-tag {
            display: flex;
            align-items: center;
            min-height: 1.25rem;
            padding-top: 0;
        }
    }

    small {
        display: block;
        font-weight: normal;
        font-size: 0.75rem;
    }

    .event-dates {
        .event-date {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 0.75rem;
            border-bottom: ${(props) => props.theme.DefaultBorder};
            padding: 0.5rem 0;

            &:last-child {
                border-bottom: none;
            }

            @media (max-width: 768px) {
                flex-wrap: wrap;
            }

            .event-date-when {
                width: 8.5rem;
                flex: none;
                padding-top: 0.15rem;

                p {
                    margin: 0;
                }

                .event-date-day {
                    font-weight: bold;
                }

                .event-date-time {
                    font-size: ${(props) => props.theme.FontSizeSm};
                    color: ${(props) => props.theme.TextColorMuted};
                }
            }

            .event-date-models {
                flex: 1 1 0;
                min-width: 0;

                .event-date-model {
                    display: flex;
                    justify-content: flex-start;
                    align-items: flex-start;
                    gap: 0.75rem;
                    margin-bottom: 0.5rem;

                    .switch-container {
                        flex: none;
                    }

                    .event-date-model-name {
                        display: block;
                        text-transform: capitalize;
                        font-size: 0.85rem;
                    }

                    &.cancelled {
                        .event-date-model-name {
                            ${(props) => props.theme.RedLineThrough(1)}
                        }
                    }
                    &.option {
                        .event-date-model-name {
                            opacity: 0.6;
                        }
                    }
                }
            }
        }
    }
`;

export const SendProjectDrawerContainer = styled.div`
    height: 100%;
    display: flex;
    flex-direction: column;
    opacity: ${(props) => props.isSending && 0.4};

    /* Scorciatoie di selezione: stesso aspetto a ogni livello, allineate a destra */
    .selection-bar.selection-actions {
        width: auto;
        margin-bottom: 0;
        padding: 0;
        background: none;
        border: none;
        flex: none;

        .ant-btn {
            height: 1.5rem;
            font-size: ${(props) => props.theme.FontSizeSm};
        }
    }

    .emails-step {
        flex: 1 1 auto;
        min-height: 0;
        overflow-y: auto;
        padding: 1.6rem;

        @media (max-width: 768px) {
            padding: 1rem;
        }
    }

    /* Il footer resta sul fondo del drawer: le due colonne scorrono per conto loro */
    .events-selection {
        position: relative;
        flex: 1 1 auto;
        min-height: 0;
        display: flex;
        flex-direction: column;

        .events-selection-body {
            flex: 1 1 auto;
            min-height: 0;
            display: flex;
            align-items: stretch;

            @media (max-width: 768px) {
                display: block;
                overflow-y: auto;
            }
        }

        .events-selection-main {
            flex: 1 1 0;
            min-width: 0;
            overflow-y: auto;

            @media (max-width: 768px) {
                overflow-y: visible;
            }
        }

        .events-selection-message {
            margin: 1rem 1.25rem;
        }
    }

    /* Colonna sinistra: decide cosa puo' essere spedito */
    .scope-filters {
        width: 20rem;
        flex: none;
        overflow-y: auto;
        border-right: ${(props) => props.theme.DefaultBorder};
        background-color: ${(props) => props.theme.SelectedBackgroundColor};

        @media (max-width: 768px) {
            width: 100%;
            overflow-y: visible;
            border-right: none;
            border-bottom: ${(props) => props.theme.DefaultBorder};
        }

        .scope-filters-header {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            gap: 1rem;
            padding: 1.25rem 1rem;
            border-bottom: ${(props) => props.theme.DefaultBorder};

            .scope-filters-title {
                margin: 0;
                font-size: ${(props) => props.theme.FontSizeSm};
                font-weight: bold;
                text-transform: uppercase;
                letter-spacing: 0.06em;
                color: ${(props) => props.theme.TextColorMuted};
            }

            .ant-select {
                width: 100%;
            }
        }

        .scope-filters-tree {
            padding-bottom: 1rem;

            .scope-filters-separator {
                margin: 1rem 0 0.25rem 0;
                padding: 0 1rem;
                font-size: ${(props) => props.theme.FontSizeXSm};
                text-transform: uppercase;
                letter-spacing: 0.1em;
                color: ${(props) => props.theme.DisabledTextColor};
            }

            .scope-node {
                display: flex;
                align-items: center;
                gap: 0.5rem;
                padding: 0.35rem 1rem;
                font-size: ${(props) => props.theme.FontSizeSm};

                &:hover {
                    background-color: ${(props) => props.theme.HoverablesBackground};
                }

                .netwalk-event-tag {
                    flex: none;
                    margin: 0;
                }

                .scope-node-label {
                    flex: 1 1 0;
                    min-width: 0;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    font-weight: bold;
                    text-transform: uppercase;
                }

                .scope-node-info {
                    flex: none;
                    font-size: ${(props) => props.theme.FontSizeXSm};
                    color: ${(props) => props.theme.TextColorMuted};
                }
            }

            .scope-node-date {
                padding-left: 2.5rem;

                .scope-node-label {
                    font-weight: normal;
                    text-transform: none;
                }
            }
        }
    }

    /* Riepilogo in cima alla colonna di destra, dove si seleziona */
    .events-selection-summary {
        position: sticky;
        top: 0;
        z-index: 3;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.6rem 1.25rem;
        background-color: ${(props) => props.theme.LightBlueBackground};
        border-bottom: ${(props) => props.theme.DefaultBorder};

        p {
            margin: 0;
        }

        .tally-main {
            font-weight: bold;
        }

        .tally-detail {
            font-size: ${(props) => props.theme.FontSizeSm};
            color: ${(props) => props.theme.TextColorMuted};
        }
    }

    /* Avviso flottante: la lista continua sotto al footer */
    .events-selection-more {
        position: absolute;
        left: 50%;
        bottom: 4.25rem;
        transform: translateX(-50%);
        z-index: 5;
        display: flex;
        align-items: center;
        gap: 0.4rem;
        padding: 0.2rem 0.9rem;
        border: ${(props) => props.theme.DarkerBorder};
        border-radius: 1rem;
        background-color: rgba(255, 255, 255, 0.95);
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
        font-size: ${(props) => props.theme.FontSizeSm};
        color: ${(props) => props.theme.TextColorMuted};
        cursor: pointer;
    }

    .events-selection-footer {
        flex: none;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 1rem;
        padding: 0.75rem 1.25rem;
        background-color: ${(props) => props.theme.BackgroundColorLight};
        border-top: ${(props) => props.theme.DefaultBorder};
        box-shadow: 0 -2px 8px rgba(0, 0, 0, 0.06);
    }

    .email-options {
        padding-left: 2rem;

        @media (max-width: 768px) {
            padding-left: 0;
        }

        display: flex;
        flex-direction: column;
        gap: 1rem;

        small {
            text-transform: uppercase;
            display: block;
            padding-bottom: 0.15rem;
            font-size: ${(props) => props.theme.FontSizeSm};
        }
        .email-options-subject {
            max-width: 50rem;
        }
        .email-options-message {
            max-width: 50rem;
        }
        .email-options-signature {
            max-width: 50rem;
        }
        .email-options-acknowledgement {
        }
    }

    .project-general-documents {
        .project-general-document {
            padding: 0.25rem 0.5rem 0.25rem 2rem;
            label.ant-checkbox-wrapper {
                font-size: ${(props) => props.theme.FontSizeSm};
                text-transform: uppercase;

                svg {
                    margin: 0 0.5rem;
                }
            }
        }
    }

    .buttons-bar {
        margin-top: 1rem;
    }
`;

export const EmailItem = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    border-bottom: ${(props) => props.theme.DefaultBorder};
    padding: 1rem 2rem;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 0.5rem 0;
        padding: 0.75rem 0;
    }

    .model-cover {
        padding: 0 1rem;

        @media (max-width: 768px) {
            display: none;
        }
    }
    .model-details {
        flex: 1 1 0;
        border-right: ${(props) => props.theme.DefaultBorder};
        padding: 0 1rem;

        @media (max-width: 768px) {
            border-right: none;
            padding: 0;
        }

        h2 {
            font-size: ${(props) => props.theme.FontSizeLg};
            font-weight: 500;
            margin-bottom: 0.25rem;
            text-transform: capitalize;
        }

        small {
            display: block;
            font-style: italic;
        }
        p {
            margin: 0;
        }
        .mail-addresses-container {
            .mail-address {
                display: flex;
                align-items: flex-start;
                justify-content: flex-start;
                margin: 0.5rem 0 0.75rem 0;
                padding-left: 0.8rem;

                &.warning {
                    color: ${(props) => props.theme.DangerColor};
                }

                .icon-container {
                    font-size: 1rem;
                    padding-right: 0.45rem;
                }
                p {
                    text-transform: lowercase;
                    padding: 0 2rem 0 1rem;
                }
                .ant-btn {
                    line-height: 2;
                }
                span.ccs {
                    font-size: ${(props) => props.theme.FontSizeSm};
                    display: block;
                    padding: 0;
                    margin: 0;
                    line-height: 1;
                }
            }
        }

        .model-documents-container {
            .model-document {
                padding: 0.25rem 0.5rem;
                label.ant-checkbox-wrapper {
                    font-size: ${(props) => props.theme.FontSizeSm};
                    text-transform: uppercase;

                    svg {
                        margin: 0 0.5rem;
                    }
                }
            }
        }
    }
    .model-actions {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 0 0 0 2rem;

        .icon-container {
            font-size: 3rem;
        }
    }
`;
